class MitQueryParamService {

    constructor() {
    }

    get(name){
      const urlSearchParams = new URLSearchParams(window.location.search);
      this.params = Object.fromEntries(urlSearchParams.entries());

      if(name){
          return this.params[name];
      }

      return this.params;
    }
    add(name, val){
      //will cause a page load, so if that's not desirable use the History API as follows:
      if ('URLSearchParams' in window) {
        var searchParams = new URLSearchParams(window.location.search)
        searchParams.set(name, val);
        var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
      }
    }
    remove(names){
      const searchParams = new URLSearchParams(window.location.search);

      for(let n in names){
          searchParams.delete(names[n]);
      }

      //update url
      var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }

}

export default MitQueryParamService;
